import { createSelector } from 'reselect';
import { FIELD_TYPES } from '@atlassian/jira-polaris-domain-field/src/field-types/index.tsx';
import type { FieldKey } from '@atlassian/jira-polaris-domain-field/src/field/types.tsx';
import { getAllFieldsByKey } from './fields.tsx';

export const createGetFilterTypeForField = (fieldKey: FieldKey) =>
	createSelector(getAllFieldsByKey, (fieldsByKey) => {
		const field = fieldsByKey[fieldKey];
		if (field !== undefined) {
			switch (field.type) {
				case FIELD_TYPES.SUMMARY:
					return 'TEXT';
				case FIELD_TYPES.INTERVAL:
					return 'INTERVAL';
				case FIELD_TYPES.NUMBER:
				case FIELD_TYPES.SLIDER:
				case FIELD_TYPES.RATING:
				case FIELD_TYPES.FORMULA:
				case FIELD_TYPES.LINKED_ISSUES:
				case FIELD_TYPES.CHECKBOX:
				case FIELD_TYPES.INSIGHTS:
					return 'NUMBER';
				case FIELD_TYPES.ASSIGNEE:
				case FIELD_TYPES.CREATOR:
				case FIELD_TYPES.REPORTER:
				case FIELD_TYPES.PEOPLE:
				case FIELD_TYPES.JSW_PEOPLE:
				case FIELD_TYPES.SINGLE_SELECT:
				case FIELD_TYPES.MULTI_SELECT:
				case FIELD_TYPES.JSW_MULTI_SELECT:
				case FIELD_TYPES.LABELS:
				case FIELD_TYPES.CUSTOM_LABELS:
				case FIELD_TYPES.STATUS:
				case FIELD_TYPES.ATLAS_GOAL:
				case FIELD_TYPES.ATLAS_PROJECT:
				case FIELD_TYPES.REACTIONS:
				case FIELD_TYPES.ISSUE_TYPE:
				case FIELD_TYPES.PLATFORM_GOALS:
				case FIELD_TYPES.CONNECTION:
				case FIELD_TYPES.TEAM:
					return 'FIELD';
				default:
					return undefined;
			}
		}
		return undefined;
	});
